import {
  Component,
  ElementRef,
  EventEmitter,
  Inject, Input,
  Output, ViewChild
} from '@angular/core';
import { DropdownComponent } from '@iv/shared/components/dropdown/dropdown.component';
import { CommonService } from 'app/core/services/common.service';
import { getGroups } from '../../redux/favorites.reducer';
import { AppStore } from '@iv/store/app.store';
import * as Redux from 'redux';
import { AppState } from '@iv/store/app.reducer';
import { Group } from '@iv/model/group';
import { InputTooltipComponent } from '@iv/shared/components/input-tooltip/input-tooltip.component';

@Component({
  selector: 'iv-live-group-dropdown',
  templateUrl: './group-dropdown.component.html',
  styleUrls: ['./group-dropdown.component.scss']
})
export class GroupDropdownComponent extends DropdownComponent {
  @ViewChild('inputTooltip') inputTooltipRef: InputTooltipComponent;

  @Input() enabledDeleteGroup = true;

  @Output() deleteGroupEvent = new EventEmitter<any>();
  @Output() renameGroupEvent = new EventEmitter<any>();

  deleteGroupPopupVisible = false;
  selectedIndex = '';
  renameGroupDisabled: boolean;
  groups: Group[] = [];

  constructor(
    protected _eref: ElementRef,
    private commonService: CommonService,
    @Inject(AppStore) private store: Redux.Store<AppState>
  ) {
    super(_eref);
  }

  onPopupCancel(popupVisible) {
    this[popupVisible] = false;
    let timeout = setTimeout(() => {
      this.showDropdown = false;
      timeout = null;
    }, 1);
  }

  onDeleteGroupClick(event, index) {
    event.stopPropagation();
    this.selectedIndex = index;
    this.deleteGroupPopupVisible = true;
  }

  onDeleteGroupApply() {
    const index = Number(this.selectedIndex);
    this.deleteGroupPopupVisible = false;
    if (this.selectedData.id === this.data[index].id) {
      this.selectedData = this.data.find(value => {
        return value.id === 14;
      });
    }
    this.deleteGroupEvent.emit(
      {
        deletedGroupId: this.data[index].id,
        newCurrentGroupId: this.selectedData.id
      }
    );
    this.data.splice(index, 1);
  }

  /*    onGroupItemClick(item, index) {
        this.selectedData = item;
        this.selectedDataChange.emit(item);
        this.onSelectItem.emit();
        this.showDropdown = false;
      }*/

  onInputRenameGroup(input: any) {
    if (/[\\\/\:\*\?\"\<\>\|]/g.test(input.value)) {
      this.renameGroupDisabled = true;
      this.inputTooltipRef.hide();
      this.inputTooltipRef.show('A group name can\'t contain any of the following characters: / \\ : * ? " < > |');
    } else {
      this.renameGroupDisabled = false;
      this.inputTooltipRef.hide();
    }
  }

  onGroupRename(event, isBlur) {
    const state = this.store.getState();
    const value = event.value.replace(/\s\s+/g, ' ').trim();
    this.groups = getGroups(state);
    if (this.isGroupExist(value) && value !== this.selectedData.name) {
      this.notify('Group with this name already exist', 'error');
      event.focus();
    } else {
      if (!this.renameGroupDisabled && value) {
        this._renameGroup(value);
        event.value = value;
      } else if (isBlur) {
        this.inputTooltipRef.hide();
        event.value = this.selectedData.name;
      }
    }
  }

  private notify(text, type) {
    this.commonService.sendNotification(text, type);
  }

  private isGroupExist(name) {
    return this.groups.some(group => group.name === name);
  }

  onBlur(event) {
    this.onGroupRename(event, true);
  }

  onEnterClick(event) {
    this.onGroupRename(event, false);
  }

  getName() {
    return this.getValue(this.data[this.selectedIndex]);
  }

  private _renameGroup(newName) {
    this.selectedData.name = newName;
    /*    this.isRename = false;*/
    this.renameGroupEvent.emit(newName);
  }
}
